"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = exports.METADATA_PROGRAM = exports.METADATA_PREFIX = exports.METADATA_SCHEMA = exports.Data = exports.Creator = exports.MetadataKey = void 0;
var METADATA_PREFIX = "metadata";
exports.METADATA_PREFIX = METADATA_PREFIX;
var METADATA_PROGRAM = "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s";
exports.METADATA_PROGRAM = METADATA_PROGRAM;
var MetadataKey;

(function (MetadataKey) {
  MetadataKey[MetadataKey["Uninitialized"] = 0] = "Uninitialized";
  MetadataKey[MetadataKey["MetadataV1"] = 4] = "MetadataV1";
  MetadataKey[MetadataKey["EditionV1"] = 1] = "EditionV1";
  MetadataKey[MetadataKey["MasterEditionV1"] = 2] = "MasterEditionV1";
  MetadataKey[MetadataKey["MasterEditionV2"] = 6] = "MasterEditionV2";
  MetadataKey[MetadataKey["EditionMarker"] = 7] = "EditionMarker";
})(MetadataKey = exports.MetadataKey || (exports.MetadataKey = {}));

var Creator =
/** @class */
function () {
  function Creator(args) {
    this.address = args.address;
    this.verified = args.verified;
    this.share = args.share;
  }

  return Creator;
}();

exports.Creator = Creator;

var Metadata =
/** @class */
function () {
  function Metadata(args) {
    var _a;

    this.key = MetadataKey.MetadataV1;
    this.updateAuthority = args.updateAuthority;
    this.mint = args.mint;
    this.data = args.data;
    this.primarySaleHappened = args.primarySaleHappened;
    this.isMutable = args.isMutable;
    this.editionNonce = (_a = args.editionNonce) !== null && _a !== void 0 ? _a : null;
  }

  return Metadata;
}();

exports.Metadata = Metadata;

var Data =
/** @class */
function () {
  function Data(args) {
    this.name = args.name;
    this.symbol = args.symbol;
    this.uri = args.uri;
    this.sellerFeeBasisPoints = args.sellerFeeBasisPoints;
    this.creators = args.creators;
  }

  return Data;
}();

exports.Data = Data;
var METADATA_SCHEMA = new Map([[Data, {
  kind: "struct",
  fields: [["name", "string"], ["symbol", "string"], ["uri", "string"], ["sellerFeeBasisPoints", "u16"], ["creators", {
    kind: "option",
    type: [Creator]
  }]]
}], [Metadata, {
  kind: "struct",
  fields: [["key", "u8"], ["updateAuthority", "pubkey"], ["mint", "pubkey"], ["data", Data], ["primarySaleHappened", "u8"], ["isMutable", "u8"] // bool
  ]
}], [Creator, {
  kind: "struct",
  fields: [["address", "pubkey"], ["verified", "u8"], ["share", "u8"]]
}]]);
exports.METADATA_SCHEMA = METADATA_SCHEMA;